import {
    CREATE_STITCHING_INWARD_FAILURE,
    CREATE_STITCHING_INWARD_REQUEST,
    CREATE_STITCHING_INWARD_SUCCESS,
    CREATE_USER_FORM_STITCHING_INWARD,
    FETCH_SINGLE_STITCHING_INWARD_FAILURE,
    FETCH_SINGLE_STITCHING_INWARD_REQUEST,
    FETCH_SINGLE_STITCHING_INWARD_SUCCESS,
    FETCH_STITCHING_INWARD_FAILURE,
    FETCH_STITCHING_INWARD_REQUEST,
    FETCH_STITCHING_INWARD_SUCCESS,
    NAVIGATE_STITCHING_INWARD_DETAILS,
    NAVIGATE_STITCHING_INWARD,
    STITCHING_INWARD_USERFORM_RESET,
    UPDATE_STITCHING_INWARD_FAILURE,
    UPDATE_STITCHING_INWARD_REQUEST,
    UPDATE_STITCHING_INWARD_SUCCESS,
    DELETE_STITCHING_INWARD_REQUEST,
    DELETE_STITCHING_INWARD_SUCCESS,
    DELETE_STITCHING_INWARD_FAILURE,
    FETCH_PENDING_STITCHING_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_STITCHING_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_STITCHING_PO_IN_INWARD_FAILURE,
    SET_ACTIVE_KEY_STITCHING_INWARD,
    RESET_FORM_DATA_WITHOUT_STITCHING_INWARD_ID,
    SET_END_DATE_STITCHING_INWARD,
    SET_START_DATE_STITCHING_INWARD,
    SET_UNIT_NAME_STITCHING_INWARD
} from './stitchingInward.actionsType';

export const STITCHING_INWARD = 'stitchingInward';

let initialState = {
    loading: false,
    stitchingInward: [],
    isStitchingInward: false,
    pendingStitchingDC: [],
    activeKey: 1,
    stitchingInwardId: '',
    stitchingInwardMasterForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,

        fldRoundoff: 0
    },
    selectedStitchingInward: {},
    stitchingInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    goBack: true,
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
};

export let stitchingInwardReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_STITCHING_INWARD_REQUEST:
        case FETCH_PENDING_STITCHING_PO_IN_INWARD_REQUEST:
        case CREATE_STITCHING_INWARD_REQUEST:
        case FETCH_SINGLE_STITCHING_INWARD_REQUEST:
        case UPDATE_STITCHING_INWARD_REQUEST:
        case DELETE_STITCHING_INWARD_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STITCHING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingInward: updatePayload
            };
        case FETCH_PENDING_STITCHING_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingStitchingDC: updatePayload
            };
        case CREATE_STITCHING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                stitchingInwardId: updatePayload[0],
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_STITCHING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedStitchingInward: updatePayload,
                stitchingInwardMasterForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_STITCHING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedStitchingInward: {},
                stitchingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                }
            };
        case DELETE_STITCHING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedStitchingInward: {}
            };
        case FETCH_STITCHING_INWARD_FAILURE:
        case FETCH_PENDING_STITCHING_PO_IN_INWARD_FAILURE:
        case FETCH_SINGLE_STITCHING_INWARD_FAILURE:
        case CREATE_STITCHING_INWARD_FAILURE:
        case UPDATE_STITCHING_INWARD_FAILURE:
        case DELETE_STITCHING_INWARD_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_STITCHING_INWARD:
            return {
                ...state,
                loading: false,
                stitchingInwardMasterForm: {
                    ...state.stitchingInwardMasterForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_STITCHING_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case STITCHING_INWARD_USERFORM_RESET:
            return {
                ...state,
                stitchingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedStitchingInward: {},
                stitchingInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_STITCHING_INWARD_ID:
            return {
                ...state,
                stitchingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_STITCHING_INWARD_DETAILS:
            return {
                ...state,
                isStitchingInward: true,
                stitchingInwardSelectedValue: updatePayload.stitchingInwardSelectedValue
            };
        case NAVIGATE_STITCHING_INWARD:
            return {
                ...state,
                isStitchingInward: false,
                goBack: false
            };
        case SET_UNIT_NAME_STITCHING_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_STITCHING_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_STITCHING_INWARD:
            return {
                ...state,
                endDate: payload
            };
        default:
            return state;
    }
};
